'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { trackCTAClick } from '@/lib/analytics';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative bg-gradient-to-br from-secondary via-secondary/95 to-secondary/90 text-white overflow-hidden ${className}`}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent rounded-full filter blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 py-24 lg:py-32 relative z-10 bg-sky-800 border-solid">
        <div className="max-w-4xl mx-auto text-center">
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-semibold mb-6 leading-tight">
            AI Orchestration, Not Just AI Implementation
          </h1>
          
          <p className="text-lg md:text-xl text-white/90 mb-10 leading-relaxed max-w-3xl mx-auto">Your trusted partner for governed AI adoption in Australia and New Zealand. We deliver measurable results with complete visibility and control, strategic AI implementation that works alongside your people.

          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              href="/partnership-inquiry"
              onClick={() => trackCTAClick('Request Strategic Consultation', 'hero_section', '/partnership-inquiry')}
              className="inline-flex items-center px-8 py-4 bg-accent text-accent-foreground font-display font-medium text-base rounded-lg hover:shadow-authority transition-all duration-300 hover:-translate-y-0.5 w-full sm:w-auto justify-center">

              Request Strategic Consultation
              <Icon name="ArrowRightIcon" size={20} className="ml-2" />
            </Link>
            
            <Link
              href="/ai-readiness-assessment"
              onClick={() => trackCTAClick('Assess Your AI Readiness', 'hero_section', '/ai-readiness-assessment')}
              className="inline-flex items-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-display font-medium text-base rounded-lg hover:bg-white/20 transition-all duration-300 w-full sm:w-auto justify-center">

              Assess Your AI Readiness
              <Icon name="ChartBarIcon" size={20} className="ml-2" />
            </Link>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;